import { z } from 'zod'
import isISO8601 from 'validator/lib/isISO8601'
import isSameDay from 'date-fns/isSameDay'
import parseISO from 'date-fns/parseISO'

import { nullableString } from '../utils/schema'
import { filtersFormSchema } from '../clients/client-filters.schema'

type CallListFormState = z.infer<typeof callListFormSchema>

const callListFormSchema = z.object({
  name: z.string().min(1, { message: 'You must provide an outreach name.' }),
  description: z.string(),
  groupIds: z
    .array(z.string())
    .min(1, { message: 'You must select at least one store.' }),
  dateRange: z
    .object({
      startDate: z
        .string()
        .refine((data) => isISO8601(data, { strict: true }), {
          message: 'You must choose a valid start date.',
        }),
      endDate: z
        .string()
        .refine(isISO8601, { message: 'You must choose a valid end date.' }),
    })
    .superRefine((val, ctx) => {
      if (isSameDay(parseISO(val.startDate), parseISO(val.endDate))) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'The start and end dates cannot be the same',
        })
      }

      if (val.startDate > val.endDate) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'The start date must be before the end date.',
        })
      }
    }),
  filter: filtersFormSchema.nullable(),
  templateId: nullableString,
})

export type { CallListFormState }
export { callListFormSchema }
